import classNames from 'classnames';
import { ButtonHTMLAttributes, PropsWithChildren } from 'react';
import './Button.scss';

export type BtnStyling =
  | 'yellow'
  | 'white'
  | 'primary'
  | 'outline'
  | 'dark'
  | 'naked'
  | 'naked-blue'
  | 'text'
  | 'red'
  | 'gray'
  | 'naked-blue';

interface Props {
  className?: string;
  styling?: BtnStyling;
  size?: 'sm' | 'lg';
}

export default function Button({
  className = '',
  styling = 'primary',
  children,
  size,
  ...rest
}: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement> & Props>) {
  const getClassName = () => {
    switch (styling as BtnStyling) {
      case 'yellow':
        return 'Button--yellow';
      case 'red':
        return 'Button--red';
      case 'naked-blue':
        return 'Button--naked--blue';
      case 'naked':
        return 'Button--naked';
      case 'text':
        return 'Button--text';
      case 'outline':
        return 'Button--secondary';
      case 'dark':
        return 'Button--dark';
      case 'white':
        return 'Button--white';
      case 'gray':
        return 'Button--grey';
      default:
        return 'Button';
    }
  };

  return (
    <button
      className={classNames(getClassName(), className, {
        [`Button--${size}`]: !!size,
      })}
      {...rest}
    >
      {children}
    </button>
  );
}
